<div mat-dialog-content >
  <div style="max-width: 100%" >
      <div  id="content" class="p-1"  style="position: relative">

      </div>
  </div>
</div>
<div mat-dialog-actions>
  <button mat-button (click)="onNoClick()" color="primary">{{'general.close' | translate}}</button>
</div>





